// <s-scent-blender> guards the custom blend form: both scent fields must hold a
// scent from the shared list (and differ), and a strength must be chosen, before
// the add button enables. The chosen strength radio writes the hidden variant
// input[name="id"] that <s-product-form> submits; scent and ratio choices travel
// as line item properties. Native `required` keeps the no-JS path guarded too.
class SScentBlender extends HTMLElement {
  #controller;

  connectedCallback() {
    this.#controller = new AbortController();
    const opts = { signal: this.#controller.signal };
    this.addEventListener('input', () => this.#update(), opts);
    this.addEventListener('change', () => this.#update(), opts);
    this.#update();
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  get #names() {
    if (!this._names) {
      this._names = new Set(Array.from(this.querySelectorAll('datalist option'), (o) => o.value));
    }
    return this._names;
  }

  #update() {
    const [first, second] = this.querySelectorAll('[data-scent-input]');
    const strength = this.querySelector('input[data-strength]:checked');
    const idInput = this.querySelector('input[name="id"]');
    const button = this.querySelector('[data-blend-add]');
    const summary = this.querySelector('[data-blend-summary]');
    const ratio = this.querySelector('input[data-ratio]:checked');
    if (!first || !second || !idInput || !button) return;

    const firstValue = first.value.trim();
    const secondValue = second.value.trim();
    const firstOk = this.#names.has(firstValue);
    const secondOk = this.#names.has(secondValue);
    const same = firstOk && secondOk && firstValue === secondValue;

    first.setCustomValidity(firstValue && !firstOk ? this.dataset.errorUnknown : '');
    second.setCustomValidity(secondValue && !secondOk ? this.dataset.errorUnknown : same ? this.dataset.errorSame : '');
    this.#showError(first, firstValue && !firstOk ? this.dataset.errorUnknown : '');
    this.#showError(second, secondValue && !secondOk ? this.dataset.errorUnknown : same ? this.dataset.errorSame : '');

    idInput.value = strength ? strength.value : '';

    const ready = firstOk && secondOk && !same && Boolean(strength) && Boolean(ratio);
    button.disabled = !ready;
    button.setAttribute('aria-disabled', String(!ready));

    if (summary) {
      if (ready) {
        const a = ratio.dataset.a; const b = ratio.dataset.b;
        summary.textContent = `${a}% ${firstValue} + ${b}% ${secondValue} · ${strength.dataset.label} · ${strength.dataset.price}`;
      } else {
        summary.textContent = this.dataset.summaryEmpty;
      }
    }
  }

  #showError(input, message) {
    const el = this.querySelector(`#${input.getAttribute('aria-describedby')}`);
    if (!el) return;
    el.textContent = message;
    el.hidden = !message;
    input.setAttribute('aria-invalid', String(Boolean(message)));
  }
}

if (!customElements.get('s-scent-blender')) customElements.define('s-scent-blender', SScentBlender);
